module.exports = __webpack_public_path__ + "static/media/4D.bce86d98.svg";